// Public configuration. The publishable key is safe to ship in the client; RLS protects the data.
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL ?? 'https://mprdthhcphxxqtlnawjg.supabase.co';
export const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? 'sb_publishable_mLGunulMejYdXkxCVzcuNw_GG52wRD3';

/** Bump when the disclaimer or consent wording changes; users are asked to accept again. */
export const CONSENT_VERSION = '2026-10-23';
